import styled from 'styled-components';
import { PlayActionEvent, PlayActionDescription } from './playEvents/PlayAction.style';
import { PlayVideoWrapper } from './playResults/PlayVideo.style';
import { TeamScoresWrapper } from './PlayScores.style';
import {
    HomeRunWrapper,
    HomeRunSubHeader,
    HomeRunSubText
} from './PlayResults.style';
import { WinProbabilityWrapper } from './playResults/WinProbability.style';
import {
    StyledBaseSVG
} from '@mlb/react-patterns/components/Basepaths/basepaths.style';
import { SituationWrapper } from '../../AtBat/summary/Summary.style.js';
import GDBREAKPOINTS from '@gameday/components/themes/breakpoints';

const { SM_MAX, SM_MIN } = GDBREAKPOINTS;
export const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid var(--gameday-filter-button-bgcolor);
  margin-bottom: 16px;
  margin-top: 16px;
`;

export const SummaryPlayEventsWrapper = styled.div.attrs(({ eventType }) => ({
    'data-game-type': eventType
}))`
  font-family: var(--gameday-primary-font);
  position: relative;
  padding-left: 57px;
  min-height: 40px;
  padding-bottom: ${({ showPlayStatus }) => showPlayStatus ? '10px' : '0px'};
  ${PlayVideoWrapper} {
    margin-top: 15px;
  }
  ${TeamScoresWrapper} {
    margin-top: 0px;
    line-height: 18px;
    color: var(--gameday-primary-font-color);
  }
  ${HomeRunWrapper} {
    color: var(--gameday-primary-font-color);
    &:before {
      display: none;
    }
    @media (min-width: ${SM_MIN}) and (max-width: ${SM_MAX}) {
      margin-right: 24px;
    }
    ${HomeRunSubHeader} {
      text-transform: initial;
      font-size: 14px;
      line-height: 14px;
      font-weight: bold;
      margin-bottom: 4px;
    }
    ${HomeRunSubText} {
      font-size: 20px;
      line-height: 20px;
      font-weight: bold;

      span {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  ${WinProbabilityWrapper} {
    font-size: 18px;
    margin-top: 2px;
    line-height: 18px;
    span {
      
      margin-right: 4px;
      &:last-child {
        margin-right: 0px;
      }
      &:not(:last-child) {
        color: var(--gameday-primary-font-color);
      }
    }
  }
  ${SituationWrapper} {
    padding: 2px 0px 8px;
    ${StyledBaseSVG} {
      margin-left: 0px;
    }
  }
`;

export const SummaryPlayEventDescription = styled(PlayActionDescription)`
  display: block;
  color: var(--gameday-primary-font-color);
  line-height: 20px;
  ${({ verticallyCenter }) => verticallyCenter ? 'padding-top: 15px;' : ''}
  ${({ needsMargin }) => needsMargin ? 'margin-bottom: 16px;' : ''}
`;

export const SummaryPlayEvent = styled(PlayActionEvent)`
  text-transform: initial;
  color: ${({ isResult }) => isResult ? 'var(--gameday-summary-event-score-color)' : 'var(--gameday-summary-play-event-color)'};
`;

export const OutsWrapper = styled.div`
  display: inline;
  font-weight: bold;
  text-transform: lowercase;
  white-space: nowrap;
`;

export const EventNodeWrapper = styled.div`
  display: inline-block;
  white-space: nowrap;
  border-radius: 18px;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
  padding-left: ${({ $isResult }) => $isResult ? '8px' : '0'};
  padding-right: ${({ $isResult }) => $isResult ? '8px' : '0'};
  color: ${({ $isResult }) => $isResult ? 'var(--gameday-summary-event-score-color)' : 'var(--gameday-summary-play-event-color)'};
  border:  ${({ $isResult }) => $isResult ? '1px solid var(--gameday-summary-event-score-color)' : 0};
  ${({ $isResult }) => $isResult ? 'margin-bottom: 4px' : ''};
`;

export const IconWrapper = styled.div`
  box-sizing: content-box;
  background-color: var(--gameday-background-color);
  left: 2px;
  top: 2px;
  height: 44px;
  width: 44px;
  position: absolute;
  border-radius: 50%;
  border: 1px solid ${({ isLoading }) => isLoading ? 'transparent' : 'var(--gameday-summary-play-event-border-color)'};
  
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    stroke-width: 0px;
    fill: var(--gameday-summary-play-icon-color);
      path {
          fill: var(--gameday-summary-play-icon-color);
      }
  }
  }
`;
